var TimeZoneInspector = function() {
	this.detect = function() {
		//http://www.onlineaspect.com/2007/06/08/auto-detect-a-time-zone-with-javascript/
		//Compares the local time to gmt time and determines the offset
		//Then checks if dst is in effect, allowing us to get the correct offset
		var rightNow = new Date();
		var jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);
		var temp = jan1.toGMTString();
		var jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
		var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
		
		var june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0);
		temp = june1.toGMTString();
		var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
		var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
		var dst = !!!(std_time_offset == daylight_time_offset);

		return {offset: std_time_offset, dst: dst};
	};
	
	this.as_string = function(dt) {
		if (dt === undefined) dt = this.detect();
		var timezone_str = '';
		//if (dt.dst) {
		//	var dst_offset = dt.offset + ((dt.offset > 0)? -1 : 1);
		//} else {
			var dst_offset = dt.offset;
		//}
		var timezone_str = '';
		if (dst_offset < 0) {
			timezone_str += '-';
		} else {
			timezone_str += '+';
		}
		var surplus = 0;
		if (Math.abs(dst_offset) % 1 > 0) {
			var surplus = Math.abs(dst_offset) % 1;
			dst_offset -= surplus;
			surplus = 60 * (surplus/100) * 100;
		}
		if (Math.abs(dst_offset) >= 10) {
			timezone_str += Math.abs(dst_offset).toString();
		} else {
			timezone_str += '0' + Math.abs(dst_offset).toString();
		}
		if (surplus > 0) {
			timezone_str += surplus.toString();
		} else {
			timezone_str += '00';
		}
		
		return timezone_str;
	};
	
	this.get_timezone = function(timezone_str, preferred_tzs, tzs) {
		var timezone = null;
		for (var i = 0; i < preferred_tzs.length; i++) {
			if (preferred_tzs[i][1].indexOf(timezone_str) >= 0) {
				timezone = preferred_tzs[i];
				break;
			}
		}
		if (timezone == null) {
			for (var i = 0; i < tzs.length; i++) {
				if (tzs[i][1].indexOf(timezone_str) >= 0) {
					timezone = tzs[i];
					break;
				}
			}
		}
		return timezone;
	};
};


//Utility for displaying time in various formats
function prettyTime(time) {
	this.time = (time)? time : new Date();
	
	this._update = function() {
		this.minute = (this.time.getMinutes() < 10)? '0' + this.time.getMinutes.toString() : this.time.getMinutes().toString();
		this.hour = this.time.getHours();
		this.ampm = (this.hour > 12)? 'pm' : 'am';
	};
	
	this.update = function() {
		this.time = new Date();
		this._update();
	};
	
	this.get24Current = function() {
		this.update();
		return this.get24();
	};
	
	this.get24 = function() {
		return $.format("{0}:{1}", this.hour, this.minute);
	};
	
	this.get12Current = function() {
		this.update();
		return this.get12();
	};
	
	this.get12 = function() {
		return $.format("{0}:{1} {2}", ((this.hour<12)?this.hour:this.hour-12), this.minute, this.ampm);
	};
	
	//Good through 24 hours.
	//TODO right now, due to not using delta time, if this is triggered at 55 seconds into a minute 5 seconds later it will say a minute passed instead of 5 seconds.
	this.getTimePassed = function() {
		var current_time = new Date();
		if (this.time.getDay() == current_time.getDay()) {
			if (this.time.getHours() == current_time.getHours()) {
				if (this.time.getMinutes() == current_time.getMinutes()) {
					var difference = current_time.getSeconds() - this.time.getSeconds();
					return $.format(interpolate(ngettext('%s second ago.', '%s seconds ago.', difference), [difference.toString()]));
				} else {
					var difference = current_time.getMinutes() - this.time.getMinutes();
					return $.format(interpolate(ngettext('%s minute ago.', '%s minutes ago.', difference), [difference.toString()]));
				}
			} else {
				var difference = current_time.getHours() - this.time.getHours();
				return $.format(interpolate(ngettext('%s hour ago.', '%s hours ago.', difference), [difference.toString()]));
			}
		} else {
			var difference = current_time.getDay() - this.time.getDay();
			return $.format(interpolate(ngettext('Yesterday', '%s days ago.', difference), [difference.toString()]));
		}
	};
	
	this.updateElement = function() {
		$('span.time-counter',this.element).text(this.getTimePassed());
		setTimeout(this.updateElement.scope(this),15000);
	};
	
	//Takes a jQuery object and uses getTimePassed every 15 seconds to update it
	this.timePassedElement = function(element) {
		if (element) {
			this.element = element;
			element.append($('<span>').addClass('time-counter').text(this.getTimePassed()));
			setTimeout(this.updateElement.scope(this),15000);
			return element;
		}
	};
	
	this._update();
}

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

Date.prototype.format = (function () {
	var	token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[\-+]\d{4})?)\b/g,
		timezoneClip = /[^\-+\dA-Z]/g,
		pad = function (val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) { val = "0" + val; }
			return val;
		};

	// Regexes and supporting functions are cached through closure
	var dF = function (mask, utc) {
		var date = this;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date();
		if (isNaN(date)) { throw SyntaxError("invalid date"); }

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var	_ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad(d),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad(m + 1),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String(y).slice(2),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad(H % 12 || 12),
				H:    H,
				HH:   pad(H),
				M:    M,
				MM:   pad(M),
				s:    s,
				ss:   pad(s),
				l:    pad(L, 3),
				L:    pad(L > 99 ? Math.round(L / 10) : L),
				t:    H < 12 ? "a"  : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A"  : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};

	return dF;
})();

// Some common format strings
Date.prototype.format.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
Date.prototype.format.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};


/**
 * Magic time parsing, based on Simon Willison's Magic date parser
 * @see http://simon.incutio.com/archive/2003/10/06/betterDateInput
 * @author Stoyan Stefanov &lt;stoyan@phpied.com&gt;
 */

/**
 * Array of objects, each has:
 * <ul><li>'re' - a regular expression</li>
 * <li>'handler' - a function for creating a date from something
 *     that matches the regular expression</li>
 * <li>'example' - an array of examples that show matching examples</li>
 * Handlers may throw errors if string is unparseable.
 * Examples are used for automated testing, so they should be updated
 *   once a regexp is added/modified.
 */
var timeParsePatterns = [
    // Now
    {   re: /^now/i,
        example: new Array('now'),
        handler: function() {
            return new Date();
        }
    },
    
    // 12 AM
    {   re: /^12:{0,1}(\d*)(?:a| a)/i,
        example: new Array('now'),
        handler: function(bits) {
            var d = new Date();
            var m = parseInt(bits[1].substring(0,2));
            d.setHours(0);
            if (isNaN(m)) {m = 0;}
            d.setMinutes(m);
            d.setSeconds(0);
            return d;
        }
    },  
    
    // a.m.
    {   re: /(\d{1,2}):(\d{1,2}):(\d{1,2})(?:a| a)/i,
        example: new Array('9:55:00 am','12:55:00 a.m.','9:55:00 a','11:5:10am','9:5:1a'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            d.setHours(h);
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(parseInt(bits[3], 10));
            return d;
        }
    },

    // p.m.
    {   re: /(\d{1,2}):(\d{1,2}):(\d{1,2})(?:p| p)/i,
        example: new Array('9:55:00 pm','12:55:00 p.m.','9:55:00 p','11:5:10pm','9:5:1p'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            if (h < 12) {h += 12;}
            d.setHours(h);
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(parseInt(bits[3], 10));
            return d;
        }
    },
    

    // a.m., no seconds
    {   re: /(\d{1,2}):(\d{1,2})(?:a| a)/i,
        example: new Array('9:55 am','12:55 a.m.','9:55 a','11:5am','9:5a'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            d.setHours(h);
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(0);
            return d;
        }
    },


    // p.m., no seconds
    {   re: /(\d{1,2}):(\d{1,2})(?:p| p)/i,
        example: new Array('9:55 pm','12:55 p.m.','9:55 p','11:5pm','9:5p'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            if (h < 12) {h += 12;}
            d.setHours(h);
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(0);
            return d;
        }
    },
    
    
    // hmmpm
    {   re: /(\d{3})(?:p| p)/i,
        example: new Array('900pm','345p','9pm','19 p','1950 pm'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1].substring(0,1));
            var m = parseInt(bits[1].substring(1,3), 10);
            var s = parseInt(bits[1].substring(3,5), 10);
            if (h < 12) {h += 12;}
            if (isNaN(m)) {m = 0;}
            if (isNaN(s)) {s = 0;}
            d.setHours(parseInt(h, 10));
            d.setMinutes(parseInt(m, 10));
            d.setSeconds(parseInt(s, 10));
            return d;
        }
    },     
    
    // p.m., hour only
    {   re: /(\d{1,2})(?:p| p)/i,
        example: new Array('9 pm','12 p.m.','9 p','11pm','9p'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            if (h < 12) {h += 12;}
            d.setHours(h);
            d.setMinutes(0);
            d.setSeconds(0);
            return d;
        }
    },

    // a.m., hour only
    {   re: /(\d{1,2})(?:a| a)/i,
        example: new Array('9 am','12 a.m.','9 a','11am','9a'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1], 10);
            d.setHours(h);
            d.setMinutes(0);
            d.setSeconds(0);
            return d;
        }
    },
    
    // hh:mm:ss
    {   re: /(\d{1,2}):(\d{1,2}):(\d{1,2})/,
        example: new Array('9:55:00','19:55:00','19:5:10','9:5:1','9:55:00 a.m.','11:55:00a'),
        handler: function(bits) {
            var d = new Date();
            d.setHours(parseInt(bits[1], 10));
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(parseInt(bits[3], 10));
            return d;
        }
    },
    // hh:mm
    {   re: /(\d{1,2}):(\d{1,2})/,
        example: new Array('9:55','19:55','19:5','9:55 a.m.','11:55a'),
        handler: function(bits) {
            var d = new Date();
            d.setHours(parseInt(bits[1], 10));
            d.setMinutes(parseInt(bits[2], 10));
            d.setSeconds(0);
            return d;
        }
    },
        
    // hmm
    {   re: /(^\d{3}$)/,
        example: new Array('900','345','9am','19','1950','195510','0955'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1].substring(0,1));
            var m = parseInt(bits[1].substring(1,3), 10);
            var s = parseInt(bits[1].substring(3,5), 10);
            if (isNaN(m)) {m = 0;}
            if (isNaN(s)) {s = 0;}
            d.setHours(parseInt(h, 10));
            d.setMinutes(parseInt(m, 10));
            d.setSeconds(parseInt(s, 10));
            return d;
        }
    },    
    
    // hhmmss
    {   re: /(^\d{1,6})$/,
        example: new Array('9','9a','9am','19','1950','195510','0955'),
        handler: function(bits) {
            var d = new Date();
            var h = parseInt(bits[1].substring(0,2));
            var m = parseInt(bits[1].substring(2,4), 10);
            var s = parseInt(bits[1].substring(4,6), 10);
            if (isNaN(m)) {m = 0;}
            if (isNaN(s)) {s = 0;}
            d.setHours(parseInt(h, 10));
            d.setMinutes(parseInt(m, 10));
            d.setSeconds(parseInt(s, 10));
            return d;
        }
    }
];

/**
 * Parses a string to figure out the time it represents
 *
 * @param string s String to parse
 * @return Date a valid Date object
 * @throws Error
 */
function parseTimeString(s) {
	//console.log(s)
    for (var i = 0; i < timeParsePatterns.length; i++) {

        var re = timeParsePatterns[i].re;
        var handler = timeParsePatterns[i].handler;
        var bits = re.exec(s);
		//console.log(re, bits)
        if (bits) {
            return handler(bits);
        }
    }
    throw new Error("Invalid time string");
}

function calculateTimeZone() {
	var rightNow = new Date();
	var jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);  // jan 1st
	var june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0); // june 1st
	var temp = jan1.toGMTString();
	var jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
	temp = june1.toGMTString();
	var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
	var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
	var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
	var dst;
	if (std_time_offset == daylight_time_offset) {
		dst = "0"; // daylight savings time is NOT observed
	} else {
		// positive is southern, negative is northern hemisphere
		var hemisphere = std_time_offset - daylight_time_offset;
		if (hemisphere >= 0)
			std_time_offset = daylight_time_offset;
		dst = "1"; // daylight savings time is observed
	}

	var value = std_time_offset;
	var hours = parseInt(value);
   	value -= parseInt(value);
	value *= 60;
	var mins = parseInt(value);
   	value -= parseInt(value);
	value *= 60;
	var secs = parseInt(value);
	var display_hours = hours;
	// handle GMT case (00:00)
	if (hours == 0) {
		display_hours = "00";
	} else if (hours > 0) {
		// add a plus sign and perhaps an extra 0
		display_hours = (hours < 10) ? "+0"+hours : "+"+hours;
	} else {
		// add an extra 0 if needed 
		display_hours = (hours > -10) ? "-0"+Math.abs(hours) : hours;
	}
	
	mins = (mins < 10) ? "0"+mins : mins;
	return display_hours+":"+mins;
}

module.exports = {
    calculateTimeZone: calculateTimeZone
};


// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/surveys/datetime.js